import React, { useState } from 'react';
// tonejs must be imoported with an alias ToneJS to avoid conflicts with the Tone object
import * as ToneJS from 'tone';
import { wrap } from './RydTestbedWrap';


function EurydicePlaybackTestbed() {
    const [synth, setSynth] = useState<ToneJS.Synth | null>(null);

    // Function to start playing a note
    const startNote = async () => {
        await ToneJS.start();
        if (!synth) {
            const newSynth = new ToneJS.Synth().toDestination();
            setSynth(newSynth);
            newSynth.triggerAttack('C4');
        } else {
            synth.triggerAttack('C4');
        }
    };

    // Function to stop playing a note
    const stopNote = () => {
        if (synth) {
            synth.triggerRelease();
        }
    };

    // Function to sequence a series of notes
    const playSequence = async () => {
        await ToneJS.start();
        const sequenceSynth = new ToneJS.Synth().toDestination();

        const sequence = new ToneJS.Sequence(
            (time, note) => {
                sequenceSynth.triggerAttackRelease(note, '8n', time);
            },
            ['C4', 'E4', 'G4', 'B4', 'C5'],
            '4n'
        );

        sequence.start(0);
        ToneJS.Transport.start();
    };

    return wrap(
        <div>
            <button
                onMouseDown={startNote}
                onMouseUp={stopNote}
                onTouchStart={startNote}
                onTouchEnd={stopNote}
            >
                Play Note
            </button>
            <button onClick={playSequence}>Play Sequence</button>
        </div>
    );
};

export default EurydicePlaybackTestbed;